<div
  class=""
  style="
    background-image: url('/src/assets/images/emblembg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 65%;
  "
>
  <mat-dialog-content [formGroup]="citizenuserForm">
    <div class="row">
      <!-- BEGIN: Phone number -->
      <div class="col-md-12">
        <mat-form-field
          appearance="outline"
          class="material-form w-full rounded-3xl"
        >
          <mat-label>{{ "Phone Number"| concat|translate }}</mat-label>
          <input
            formControlName="Phone Number"
            matInput
            placeholder="255*********"
          />
          <mat-error>
            <span
              *ngIf="
                !citizenuserForm.get('userPhoneNumber').valid &&
                citizenuserForm.get('userPhoneNumber').touched
              "
            >
              {{ "Use a valid Phone Number"| concat|translate }}
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <!-- END: Phone number -->
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-between mt-2">
          <button
            class="bg-tertiary-500 rounded-3xl px-3 py-2 text-white"
            (click)="closeModal($event)"
          >
            {{ "Cancel"| concat|translate }}
          </button>
          <button
            [disabled]="citizenuserForm?.invalid"
            class="bg-primary-500 px-3 py-2 rounded-3xl text-white"
            (click)="submitForm()"
          >
            {{ " Submit"| concat|translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
